"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toc = exports.title = exports.slug = exports.pageId = exports.navTitle = exports.name = exports.metaDescription = exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("@mdx-js/react");
/*@jsxRuntime automatic @jsxImportSource react*/
// translate-ignore

const pageId = exports.pageId = 29844694128;
const slug = exports.slug = 'guides/cms/content/templates/types/blog';
// translate-ignore
const navTitle = exports.navTitle = 'Blog templates';
const title = exports.title = 'Blog templates';
const name = exports.name = 'Blog templates';
const metaDescription = exports.metaDescription = "Blog listing and blog post templates can be used to customize the appearance of a site's blog. ";
const toc = exports.toc = [{
  "depth": 0,
  "id": "create-a-shared-template-for-the-listing-and-post-pages",
  "label": "Create a shared template for the listing and post pages",
  "parent": null
}, {
  "depth": 0,
  "id": "create-separate-listing-and-post-templates",
  "label": "Create separate listing and post templates",
  "parent": null
}, {
  "depth": 1,
  "id": "listing-page-templates",
  "label": "Listing page templates",
  "parent": "create-separate-listing-and-post-templates"
}, {
  "depth": 0,
  "id": "create-a-blog-listing-module",
  "label": "Create a blog listing module",
  "parent": null
}, {
  "depth": 0,
  "id": "blog-author%2C-tag%2C-and-simple-listing-pages",
  "label": "Blog author, tag, and simple listing pages",
  "parent": null
}, {
  "depth": 1,
  "id": "if-blog_author",
  "label": "If blog_author",
  "parent": "blog-author%2C-tag%2C-and-simple-listing-pages"
}, {
  "depth": 1,
  "id": "if-tag",
  "label": "If tag",
  "parent": "blog-author%2C-tag%2C-and-simple-listing-pages"
}, {
  "depth": 1,
  "id": "if-not-simple_list_page",
  "label": "If not simple_list_page",
  "parent": "blog-author%2C-tag%2C-and-simple-listing-pages"
}, {
  "depth": 0,
  "id": "listing-pagination",
  "label": "Listing pagination",
  "parent": null
}, {
  "depth": 0,
  "id": "boilerplate-markup",
  "label": "Boilerplate markup",
  "parent": null
}, {
  "depth": 1,
  "id": "post-template-markup",
  "label": "Post template markup",
  "parent": "boilerplate-markup"
}, {
  "depth": 1,
  "id": "listing-template-markup",
  "label": "Listing template markup",
  "parent": "boilerplate-markup"
}, {
  "depth": 0,
  "id": "related-resources",
  "label": "Related resources",
  "parent": null
}];
function _createMdxContent(props) {
  const _components = Object.assign({
      h1: "h1",
      p: "p",
      h2: "h2",
      code: "code",
      a: "a",
      pre: "pre",
      ul: "ul",
      li: "li",
      strong: "strong",
      img: "img",
      h3: "h3"
    }, (0, _react.useMDXComponents)(), props.components),
    {
      ProductTier,
      Alert
    } = _components;
  if (!Alert) _missingMdxReference("Alert", true);
  if (!ProductTier) _missingMdxReference("ProductTier", true);
  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(0, _jsxRuntime.jsx)(_components.h1, {
      children: "Blog templates"
    }), "\n", (0, _jsxRuntime.jsx)(ProductTier, {
      tiers: ['cms-professional', 'cms-enterprise', 'marketing_hub-professional', 'marketing_hub-enterprise', 'cms-starter']
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "HubSpot blogs consist of blog listing pages and the individual blog posts. In addition to listing the individual blog posts, the blog listing template is also used for rendering the author and tag listing pages. You can either create a single template to render all listing and blog post pages, or you can create two separate templates."
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "Below, learn about blog template markup, template components, and customization options."
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Create a shared template for the listing and post pages"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["To create one template that renders the listing and post pages, add the ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "templateType: blog"
      }), " ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "/guides/cms/content/templates/types/html-hubl-templates#template-annotations",
        children: "annotation"
      }), " to the top of your template file. When using one template to render both, you'll use an ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "/reference/cms/hubl/if-statements",
        children: "if statement"
      }), " that evaluates whether the user is looking at a listing page or an individual post. If you are using the ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "/guides/cms/content/templates/types/drag-and-drop-templates",
        children: "drag and drop design manager layouts"
      }), ", this ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "if"
      }), " statement is built into the UI of blog content module buttons."]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["By using the ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "if is_listing_view"
      }), " statement, you can write your post and listing code separately."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-hubl",
        children: "{% if is_listing_view %}\n    Markup for blog listing template\n{% else %}\n    Markup for blog post template\n{% endif %}\n"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Create separate listing and post templates"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["Alternatively, you can choose to have separate templates for ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "/guides/cms/content/templates/overview#blog-post",
        children: "blog post"
      }), " and ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "/guides/cms/content/templates/overview#blog-listing",
        children: "listing pages"
      }), " which can help make your code cleaner and easier to read as a developer, while making the templates easier to select for content creators. Rather than using the ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "templateType: blog"
      }), " annotation at the top of the one template, include the following ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "/guides/cms/content/templates/overview#template-types",
        children: "annotations"
      }), " at the top of your two templates:"]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.strong, {
          children: "Blog post template:"
        }), " ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "templateType: blog_post"
        })]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.strong, {
          children: "Blog listing template:"
        }), " ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "templateType: blog_listing"
        })]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: (0, _jsxRuntime.jsx)(_components.img, {
        src: "https://www.hubspot.com/hubfs/Knowledge_Base_2021/Developer/template-annotation-blog-listing.png",
        alt: "template-annotation-blog-listing"
      })
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["When building separate post and listing templates, the ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "is_listing_view"
      }), " check is not required. Instead, you'll manually ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "https://knowledge.hubspot.com/blog/manage-your-blog-template-and-settings#select-your-blog-templates",
        children: "select separate templates"
      }), " within the account's blog settings."]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["You can also ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "https://developers.hubspot.com/docs/cms/guides/migrate/blog-to-blog_listing",
        children: "migrate an existing unified blog template to be either a blog post template or blog listing template"
      }), "."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "Listing page templates"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["The ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "templateType: blog_listing"
      }), " annotation makes the template available for ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "https://knowledge.hubspot.com/blog/manage-your-blog-template-and-settings",
        children: "selection under blog settings"
      }), " specifically for the listing view. With this template type, content creators can also edit the listing page within the page editor. By also including ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "/guides/cms/content/templates/drag-and-drop/overview",
        children: "drag and drop areas"
      }), " in the template, modules can be added and removed in the page editor like they can for other CMS pages. Check out the ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "https://github.com/HubSpot/cms-theme-boilerplate/pull/349",
        children: "CMS boilerplate blog templates"
      }), " to see examples of including drag and drop areas."]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["The listing of posts is generated by a ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "/reference/cms/hubl/loops",
        children: "for loop"
      }), " that iterates through your blog posts. ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "contents"
      }), " is a predefined sequence of content that contains all the posts contained in that blog."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-hubl",
        children: "{% for content in contents %}\n    <div class=\"post-item\">\n        Post item markup that renders with each iteration.\n    </div>\n{% endfor %}\n"
      })
    }), "\n", (0, _jsxRuntime.jsx)(Alert, {
      type: "info",
      children: (0, _jsxRuntime.jsxs)(_components.p, {
        children: ["It's recommended to make all text strings on your blog listing template controlled by fields. This makes it easier to create ", (0, _jsxRuntime.jsx)(_components.a, {
          href: "/guides/cms/content/multi-language-content",
          children: "multilingual"
        }), " blogs and gives content creators more control."]
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Create a blog listing module"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["You can enable content creators to place modules on the perimeter of the blog listing content, such as on the sides, or above and below. To enable this, it's recommended to create a blog listing module that uses a ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "/guides/cms/content/templates/types/blog#blog-listing-for-loop",
        children: "blog listing for loop"
      }), ". Check out the ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "https://github.com/HubSpot/cms-theme-boilerplate/tree/main/src/modules/blog-listings.module",
        children: "CMS boilerplate blog listing module"
      }), " for an example. ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "https://github.com/HubSpot/cms-theme-boilerplate/tree/main/src/modules/blog-listings.module"
      })]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["While HubSpot provides ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "https://knowledge.hubspot.com/blog/manage-your-blog-template-and-settings#select-your-blog-templates",
        children: "blog settings"
      }), " for showing summaries and using featured images, you can also build these features into your module. This enables content creators to set these features within the page editor, rather than blog settings."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Blog author, tag, and simple listing pages"
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "In additional to the blog post and blog listing pages, HubSpot blogs also have pages for blog authors, blog post tags, and simple listing pages. These additional pages use the same template as the blog listing page to render their content."
    }), "\n", (0, _jsxRuntime.jsx)(Alert, {
      type: "info",
      children: (0, _jsxRuntime.jsx)(_components.p, {
        children: "Because the listing page template is also shared by the blog author, tag, and simple listing page, updates published to the template will also apply to those pages."
      })
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["To configure the layout of these pages individually, you can use ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "if"
      }), " statements to conditionally render content for each type of page."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "If blog_author"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["Within the standard HubSpot blog listing markup, there is an ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "if blog_author"
      }), " statement. This statement evaluates as true when viewing an author's page, which lists the posts published by the author. The boilerplate template includes the author's name, bio, and social media accounts."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-hubl",
        children: "{% if blog_author %}\n  <div class=\"blog-header\">\n    <div class=\"blog-header__inner\">\n      {% if blog_author.avatar %}\n      <div class=\"blog-header__author-avatar\" style=\"background-image: url('{{ blog_author.avatar }}');\"></div>\n      {% endif %}\n      <h1 class=\"blog-header__title\">{{ blog_author.display_name }}</h1>\n      <h4 class=\"blog-header__subtitle\">{{ blog_author.bio }}</h4>\n      {% if blog_author.has_social_profiles %}\n        <div class=\"blog-header__author-social-links\">\n          {% if blog_author.website %}\n            <a href=\"{{ blog_author.website }}\" target=\"_blank\">\n              {% icon name=\"link\" style=\"SOLID\" width=\"10\" %}\n            </a>\n          {% endif %}\n          {% if blog_author.facebook %}\n            <a href=\"{{ blog_author.facebook }}\" target=\"_blank\">\n              {% icon name=\"facebook-f\" style=\"SOLID\" width=\"10\" %}\n            </a>\n          {% endif %}\n          {% if blog_author.linkedin %}\n            <a href=\"{{ blog_author.linkedin }}\" target=\"_blank\">\n              {% icon name=\"linkedin-in\" style=\"SOLID\" width=\"10\" %}\n            </a>\n          {% endif %}\n          {% if blog_author.twitter %}\n            <a href=\"{{ blog_author.twitter }}\" target=\"_blank\">\n              {% icon name=\"twitter\" style=\"SOLID\" width=\"10\" %}\n            </a>\n          {% endif %}\n        </div>\n      {% endif %}\n    </div>\n  </div>\n{% else %}\n"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "If tag"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["You can use an ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "if tag"
      }), " statement to only render code on a blog topic listing page, which visitors can see when clicking a blog topic on your site. The example below is a snippet that uses the page title variable to automatically print the tag name at the top of a tag listing page."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-hubl",
        children: "{% if tag %}\n    <h3>Posts about {{ page_meta.html_title|split(\" | \")|last }}</h3>\n{% endif %}\n"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "If not simple_list_page"
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "There are two types of blog listing pages that can be rendered to display blog post listings: the regular listing page, and a simple listing page:"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: "The regular listing iterates through the number of posts specified by the post listing blog setting and paginates accordingly."
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["A simple listing is a listing of all your posts and does not support pagination. The simple listing is not affected by the ", (0, _jsxRuntime.jsx)(_components.a, {
          href: "/guides/cms/content/website-settings#number-of-posts-per-listing-page",
          children: "post limit blog setting"
        }), " and generally just contains links to the most recent 200 blog posts. The address of your simple listing page is the URL for your blog with ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "/all"
        }), " added to the end of the path."]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["You can use an ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "if not simple_list_page"
      }), " statement to determine what to render in a simple versus regular listing. A simplified version of this statement is shown below."]
    }), "\n", (0, _jsxRuntime.jsx)(Alert, {
      type: "info",
      children: (0, _jsxRuntime.jsxs)(_components.p, {
        children: ["Note that the ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "if"
        }), " statement uses reverse logic, which means that the ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "else"
        }), " defines the simple listing view. Optionally, you could use an ", (0, _jsxRuntime.jsx)(_components.a, {
          href: "/reference/cms/hubl/if-statements#unless-statements",
          children: "unless statement"
        }), " instead."]
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-hubl",
        children: "{% if not simple_list_page %}\n    Iterated post markup for regular listing\n{% else %}\n    <h2 class=\"post-listing-simple\"><a href=\"{{content.absolute_url}}\">{{ content.name }}</a></h2>\n{% endif %}\n"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Listing pagination"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["Blog listing pages have auto-generated pagination. Your listing template can include logic to allow visitors to easily pages through your blog posts. The ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "https://boilerplate.hubspotcms.com/blog",
        children: "boilerplate blog"
      }), " accomplishes simple, number pagination through the ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "https://github.com/HubSpot/cms-theme-boilerplate/blob/main/src/modules/blog-pagination.module/module.html",
        children: "following markup"
      }), ":"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-hubl",
        children: "{% if contents.total_page_count > 1 %}\n<div class=\"blog-pagination\">\n    {% set page_list = [-2, -1, 0, 1, 2] %}\n    {% if contents.total_page_count - current_page_num == 1 %}{% set offset = -1 %}\n    {% elif contents.total_page_count - current_page_num == 0 %}{% set offset = -2 %}\n    {% elif current_page_num == 2 %}{% set offset = 1 %}\n    {% elif current_page_num == 1 %}{% set offset = 2 %}\n    {% else %}{% set offset = 0 %}{% endif %}\n\n    <a class=\"blog-pagination__link blog-pagination__prev-link {{ \"blog-pagination__prev-link--disabled\" if !last_page_num }}\" href=\"{{ blog_page_link(last_page_num) }}\">\n    {% icon name=\"chevron-left\" style=\"SOLID\", width=\"13\", no_wrapper=True %}\n    Prev\n    </a>\n    {% for page in page_list %}\n    {% set this_page = current_page_num + page + offset %}\n    {% if this_page > 0 and this_page <= contents.total_page_count %}\n        <a class=\"blog-pagination__link blog-pagination__number-link {{ \"blog-pagination__link--active\" if this_page == current_page_num }}\" href=\"{{ blog_page_link(this_page) }}\">{{ this_page }}</a>\n    {% endif %}\n    {% endfor %}\n    <a class=\"blog-pagination__link blog-pagination__next-link {{ \"blog-pagination__next-link--disabled\" if !next_page_num }}\" href=\"{{ blog_page_link(current_page_num + 1) }}\">\n    Next\n    {% icon name=\"chevron-right\" style=\"SOLID\", width=\"13\", no_wrapper=True %}\n    </a>\n</div>\n{% endif %}\n"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Boilerplate markup"
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "Below, view the boilerplate markup for the blog post and blog listing page templates. You can also view this markup in the CMS boilerplate on GitHub, as listed in each section."
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "Post template markup"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["All blog posts in a blog are generated by a single blog template. ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "Content"
      }), " is a predefined object of data that contains information about the requested blog post. ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "https://boilerplate.hubspotcms.com/blog",
        children: "Boilerplate posts"
      }), " are rendered with the ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "https://github.com/HubSpot/cms-theme-boilerplate/blob/master/src/templates/blog-post.html",
        children: "following markup"
      }), ":"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-hubl",
        children: "<div class=\"content-wrapper\">\n  <div class=\"blog-post\">\n    <h1>{{ content.name }}</h1>\n    <div class=\"blog-post__meta\">\n      <a href=\"{{ blog_author_url(group.id, content.blog_post_author.slug) }}\">\n        {{ content.blog_post_author.display_name }}\n      </a>\n      <div class=\"blog-post__timestamp\">\n        {{ content.publish_date_localized }}\n      </div>\n    </div>\n    <div class=\"blog-post__body\">\n      {{ content.post_body }}\n    </div>\n    {% if content.tag_list %}\n    <div class=\"blog-post__tags\">\n      {% icon name=\"tag\" style=\"SOLID\" %}\n      {% for tag in content.tag_list %}\n        <a class=\"blog-post__tag-link\" href=\"{{ blog_tag_url(group.id, tag.slug) }}\">{{ tag.name }}</a>{% if not loop.last %},{% endif %}\n      {% endfor %}\n    </div>\n    {% endif %}\n  </div>\n  <div class=\"blog-comments\">\n    {% module \"blog_comments\" path=\"@hubspot/blog_comments\", label=\"Blog Comments\" %}\n  </div>\n</div>\n"
      })
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["Blog post author information is also available within the ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "content"
      }), " data."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-hubl",
        children: "<img alt=\"{{ content.blog_post_author.display_name }}\" src=\"{{ content.blog_post_author.avatar }}\">\n<h3>Written by <a class=\"author-link\" href=\"{{ blog_author_url(group.id, content.blog_post_author.slug) }}\">{{ content.blog_post_author.display_name }}</a></h3>\n<p>{{ content.blog_post_author.bio }}</p>\n{% if content.blog_post_author.has_social_profiles %}\n    <div class=\"hs-author-social-section\">\n        <div class=\"hs-author-social-links\">\n            {% if content.blog_post_author.facebook %}\n                <a href=\"{{ content.blog_post_author.facebook }}\" target=\"_blank\" class=\"hs-author-social-link hs-social-facebook\">Facebook</a>\n            {% endif %}\n            {% if content.blog_post_author.linkedin %}\n                <a href=\"{{ content.blog_post_author.linkedin }}\" target=\"_blank\" class=\"hs-author-social-link hs-social-linkedin\">LinkedIn</a>\n            {% endif %}\n            {% if content.blog_post_author.twitter %}\n                <a href=\"{{ content.blog_post_author.twitter }}\" target=\"_blank\" class=\"hs-author-social-link hs-social-twitter\">Twitter</a>\n            {% endif %}\n            {% if content.blog_post_author.google_plus %}\n                <a href=\"{{ content.blog_post_author.google_plus }}?rel=author\" target=\"_blank\" class=\"hs-author-social-link hs-social-google-plus\">Google+</a>\n            {% endif %}\n        </div>\n    </div>\n{% endif %}\n"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "Listing template markup"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["The ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "https://boilerplate.hubspotcms.com/blog",
        children: "boilerplate blog listing page"
      }), " contents for loop is rendered with the ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "https://github.com/HubSpot/cms-theme-boilerplate/blob/master/src/templates/blog-index.html",
        children: "following markup"
      }), ":"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-hubl",
        children: "{% for content in contents %}\n    {# On the blog homepage the first post will be featured above older posts #}\n    {% if (loop.first && current_page_num == 1 && !topic) %}\n    <div class=\"blog-index__post blog-index__post--large\">\n        <a class=\"blog-index__post-image blog-index__post-image--large\"\n        {% if content.featured_image %}\n            style=\"background-image: url('{{ content.featured_image }}')\";\n        {% endif %}\n        href=\"{{ content.absolute_url }}\"></a>\n        <div class=\"blog-index__post-content  blog-index__post-content--large\">\n        <h2><a href=\"{{ content.absolute_url }}\">{{ content.name }}</a></h2>\n        {{ content.post_list_content }}\n        </div>\n    </div>\n    {% else %}\n    <div class=\"blog-index__post blog-index__post--small\">\n        <a class=\"blog-index__post-image blog-index__post-image--small\"\n        {% if content.featured_image %}\n            style=\"background-image: url('{{ content.featured_image }}')\";\n        {% endif %}\n        href=\"{{ content.absolute_url }}\"></a>\n        <div class=\"blog-index__post-content  blog-index__post-content--small\">\n        <h2><a href=\"{{ content.absolute_url }}\">{{ content.name }}</a></h2>\n        {{ content.post_list_content|truncatehtml(100) }}\n        </div>\n    </div>\n    {% endif %}\n{% endfor %}\n"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Related resources"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: (0, _jsxRuntime.jsx)(_components.a, {
          href: "/reference/cms/hubl/variables#blog-variables",
          children: "Blog variables"
        })
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: (0, _jsxRuntime.jsx)(_components.a, {
          href: "/guides/cms/content/templates/types/blog",
          children: "Blog templates"
        })
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: (0, _jsxRuntime.jsx)(_components.a, {
          href: "/guides/cms/content/themes/hubspot-cms-boilerplate",
          children: "HubSpot Theme Boilerplate"
        })
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: (0, _jsxRuntime.jsx)(_components.a, {
          href: "https://knowledge.hubspot.com/blog/create-a-new-blog",
          children: "How to create a blog"
        })
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: (0, _jsxRuntime.jsx)(_components.a, {
          href: "https://knowledge.hubspot.com/blog/import-a-blog-into-hubspot",
          children: "Import your blog into HubSpot"
        })
      }), "\n"]
    })]
  });
}
function MDXContent(props = {}) {
  const {
    wrapper: MDXLayout
  } = Object.assign({}, (0, _react.useMDXComponents)(), props.components);
  return MDXLayout ? (0, _jsxRuntime.jsx)(MDXLayout, Object.assign({}, props, {
    children: (0, _jsxRuntime.jsx)(_createMdxContent, props)
  })) : _createMdxContent(props);
}
var _default = exports.default = MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}